import { z } from 'zod'
import { pageQuery } from './common.ts'

export const auditQuery = pageQuery.extend({
  actorStaffId: z.string().uuid().optional(),
  action: z.string().trim().max(60).optional(),
  entity: z.string().trim().max(40).optional(),
})
export type AuditQuery = z.infer<typeof auditQuery>
